// Services
import { AbstractDataClient } from '~/misc/services/data-client';

// Models
import { ManagerOpportunityModel } from '~/modules/manager/models/opportunity.model';

export class ManagerOpportunityDataClient extends AbstractDataClient<ManagerOpportunityModel> {
  constructor() {
    super(new ManagerOpportunityModel());
  }
}
